import type { LumpsumAllocationCategory, LumpsumAllocationExecutedRecommendation } from '../../../../api/allocation.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { AllocationExecutedFundCard } from '../cards/AllocationExecutedFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type AllocationExecutedBucketAccordionProps = {
  category: LumpsumAllocationCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function AllocationExecutedBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: AllocationExecutedBucketAccordionProps) {
  const executedRecommendations = getCategoryBucketItems<LumpsumAllocationExecutedRecommendation>(category?.executedRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.ALLOCATION,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.executedRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.executedRecommendations]}
      count={executedRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumAllocation,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.executedRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {executedRecommendations.map((recommendation, recommendationIndex) => (
        <AllocationExecutedFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          categoryName={category?.categoryName ?? ''}
          showBottomDivider={recommendationIndex < executedRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
